import { render, staticRenderFns } from "./CpE_RecReminder_List.vue?vue&type=template&id=5b8b08a2"
import script from "./CpE_RecReminder_List.vue?vue&type=script&lang=js"
export * from "./CpE_RecReminder_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports